const crmRoutes = {
  'accompaniment': 'CRMAccompaniment'
};

export default crmRoutes;